import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">MyHSReunion · Your Reunion Planning Partner</p>
        <h1>Reconnect and Celebrate Your High School Memories</h1>
        <p className="lede">
          MyHSReunion provides all the tools and resources you need to effortlessly organize your high school reunion. From event planning to guest management, we’ve got you covered.
        </p>
        <div className="cta-row">
          <a href="/start-planning" className="primary">
            Start Planning Your Reunion
          </a>
          <a href="/resources" className="secondary">
            Explore Our Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Easy Event Planning</h2>
          <p>
            Utilize our intuitive platform to create and manage your reunion event with ease. Customize every detail to make your reunion unforgettable.
          </p>
        </article>
        <article>
          <h2>Stay Connected</h2>
          <p>
            Keep your classmates informed and engaged with our communication tools. Share updates, collect RSVPs, and foster connections before and after the event.
          </p>
        </article>
        <article>
          <h2>Comprehensive Resources</h2>
          <p>
            Access a wealth of planning resources, including venue suggestions, catering options, and tips for a successful reunion. We’re here to support you every step of the way.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;